import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../App.css';

function LandingPage() {
  return (
    <div className="landing-page">
      <Navbar />
      
      {/* Hero Section */}
      <header className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Stop Hiring "AI-Generated" Candidates.</h1>
          <p className="hero-subtitle">
            Instantly verify technical skills with AI-powered scenario assessments. 
            No fluff. No trivia. Just real-world proof.
          </p>
          <div className="hero-buttons">
            <Link to="/signup" className="cta-button primary">Get Started for Free</Link>
            
            {/* --- UPDATED LINK TO NEW PAGE --- */}
            <Link to="/how-it-works" className="cta-button secondary">See How It Works</Link>
            {/* -------------------------------- */}
          </div>
        </div>
      </header>

      {/* Features Section (Quick Summary) */}
      <section className="features-section">
        <h2>How LuxerAssess Works</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">1</div>
            <h3>Job Description & Resume</h3>
            <p>Our AI analyzes the job requirements against the candidate's claims to find the "gap."</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">2</div>
            <h3>Generate Assessment</h3>
            <p>We instantly create 3 custom, scenario-based questions that test deep understanding.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">3</div>
            <h3>AI Grading</h3>
            <p>The candidate answers, and our AI grades them against an expert rubric. You get a score instantly.</p>
          </div>
        </div>
      </section>

     {/* --- NEW SECTION: VISUAL PROOF --- */}
      <section className="proof-section" style={{textAlign: 'center', padding: '0 20px 60px 20px'}}>
        
        {/* NEW HEADLINE */}
        <h3 style={{color: '#0052cc', marginBottom: '10px', fontSize: '28px', fontWeight: 'bold'}}>
          The Perfect Score That Wasn't.
        </h3>
        
        {/* NEW SUB-HEADLINE */}
        <p style={{fontSize: '18px', color: '#4b5563', marginBottom: '40px', maxWidth: '600px', margin: '0 auto 40px auto'}}>
          Most platforms would have ranked this candidate #1. We flagged them instantly.
        </p>

        <div className="proof-image-container">
            <img 
              src="/report-preview.png" 
              alt="LuxerAssess Candidate Report showing high score but low integrity" 
              className="proof-image"
            />
        </div>
      </section>
      {/* ----------------------------------------------- */}

      <Footer />

    </div>
  );
}

export default LandingPage;